import { Box, Button, Typography } from "@carrotfertility/carotene-core"
import React from "react"

type BookingFlowErrorProps = {
  onRetry?: () => void
  onExit?: () => void
  exitLabel?: string
}

export function BookingFlowError({ onRetry, onExit, exitLabel = "Go home" }: BookingFlowErrorProps): JSX.Element {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(theme.tokens.spacing.md),
        maxInlineSize: 640
      })}
    >
      <Typography variant="h1">Something&rsquo;s not working</Typography>
      <Typography variant="body1">
        {onRetry
          ? "We couldn’t load your booking. Please try again, or head back home and start over."
          : "We couldn’t load your booking. Please go back and try again later."}
      </Typography>
      <Box sx={(theme) => ({ display: "flex", gap: theme.spacing(theme.tokens.spacing.sm) })}>
        {onRetry && (
          <Button color="secondary" onClick={onRetry}>
            Try again
          </Button>
        )}
        {onExit && (
          <Button variant="outlined" onClick={onExit}>
            {exitLabel}
          </Button>
        )}
      </Box>
    </Box>
  )
}
